import { render, staticRenderFns } from "./CommonTextBoxLarge.vue?vue&type=template&id=0501ffb2"
import script from "./CommonTextBoxLarge.vue?vue&type=script&lang=js"
export * from "./CommonTextBoxLarge.vue?vue&type=script&lang=js"
import style0 from "./CommonTextBoxLarge.vue?vue&type=style&index=0&id=0501ffb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports